import React from "react"
import { useMainEnterpriseId } from "../../hooks/enterprise"
import { useShopId } from "../../hooks/shop"
import Link from "next/link"
import { useShopSalePointFindAll } from "../../hooks/shopSalePoint"

export default function ShopSalePointList() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()

  const { shopSalePoints, isError, isLoading } = useShopSalePointFindAll(
    enterpriseId,
    { shopId }
  )

  if (isLoading) {
    return <p>Загрузка...</p>
  }

  if (isError) {
    return <p>Ошибка: {isError}</p>
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
      {shopSalePoints &&
        shopSalePoints.map((shopSalePoint) => (
          <div
            key={shopSalePoint.id}
            className="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
          >
            <div className="min-w-0 flex-1">
              <Link
                href={`/e/${enterpriseId}/${shopId}/${shopSalePoint.id}`}
                className="focus:outline-none"
              >
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-sm font-medium text-gray-900">
                  {shopSalePoint.title}
                </p>
              </Link>
            </div>
          </div>
        ))}
    </div>
  )
}
